import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>关注我</p>
      <div className="social-links">
        <a href="https://x.com/yohjizz" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="https://discord.com/channels/1344492435794825270/1344492435794825273" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-discord"></i>
        </a>
        <a href="https://github.com/yohji-yohji" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-github"></i>
        </a>
      </div>
      <div className="copyright">
        © {new Date().getFullYear()} yoji | 玩的开心！
      </div>
    </footer>
  );
};

export default Footer; 